import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import InputName from "../../common/Input/InputName";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
import { FaEye, FaEyeSlash } from "react-icons/fa";
const AddUpdateClient = ({
  showModal,
  setModalVisible,
  handleChange,
  modalAction,
  formData,
  handleAddOrUpdateAccount,
  handleRoleChange,
  handleClientTypeChange,
  clientTypes,
  roles,
  setInputError,
  setShowNewPassword,
  showNewPassword,
  submitLoading,
}) => {
  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="md"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create" ? "Add client" : "Update client"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleAddOrUpdateAccount}>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group">
                <InputName
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder=" Enter Name"
                  label="Name"
                  required={true}
                  setInputNameError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputNumber
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  label="Phone"
                  placeholder="Enter Mobile Number"
                  setInputNumberError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputEmail
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  label="Email"
                  placeholder="Enter Email"
                  setInputEmailError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="password" className="col-form-label">
                Create New Password:
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #d3d3d3",
                  borderRadius: "0.5rem",
                }}
              >
                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-control"
                  id="password"
                  placeholder="Enter new password"
                  name="password"
                  value={formData.password}
                  style={{ flex: 1, border: "none" }}
                  onChange={handleChange}
                />
                <div
                  className="input-group-append"
                  style={{ cursor: "pointer", paddingRight: "10px" }}
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Role</label>
                <Select
                  isMulti
                  value={formData?.role || []}
                  placeholder="Please select role"
                  onChange={(selectedOption) =>
                    handleRoleChange(selectedOption, "role")
                  }
                  options={roles?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Client Type</label>
                <Select
                  isMulti
                  value={formData?.clientType || []}
                  required={true}
                  placeholder="Please select ClientType"
                  onChange={(selectedOption) =>
                    handleClientTypeChange(selectedOption, "clientType")
                  }
                  options={clientTypes?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group d-flex align-items-center">
                <label htmlFor="status" className="col-form-label me-3">
                  Status:
                </label>
                {["Active", "Inactive", "Deleted"].map((status) => (
                  <div className="form-check me-3" key={status}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id={status.toLowerCase()}
                      value={status}
                      checked={formData.status === status}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={status.toLowerCase()}
                    >
                      {status}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-success"
              disabled={submitLoading}
            >
              {submitLoading ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
              ) : null}
              {submitLoading
                ? "Please wait..."
                : modalAction === "create"
                  ? "Add Client"
                  : "Update Client"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddUpdateClient;
